import { render, staticRenderFns } from "./customer-user-allocation.vue?vue&type=template&id=7998278c&"
import script from "./customer-user-allocation.vue?vue&type=script&lang=js&"
export * from "./customer-user-allocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports